import React, { FC } from 'react'

import { IconSocialFacebookProps } from './IconSocialFacebook.types'
import * as Styled from './styles/IconSocialFacebook.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSocialFacebook: FC<IconSocialFacebookProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSocialFacebookProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconSocialFacebookProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M136 0H24A24.07 24.07 0 0 0 0 24v112a24.07 24.07 0 0 0 24 24h61V93H71V70h14V56.58C85 38.11 92.28 27 113.88 27H133v23h-11.25c-8.3 0-8.75 2.73-8.75 8.76V70h19.35l-2.43 23H113v67h23a24.07 24.07 0 0 0 24-24V24a24.07 24.07 0 0 0-24-24z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSocialFacebook
